import * as React from "react";
const SvgFiRrCircleM = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-m_svg__a)">
      <path
        fill="#062147"
        d="M12.04.02c-6.618 0-12 5.382-12 12s5.382 12 12 12c6.616 0 12-5.383 12-12s-5.385-12-12-12m0 22c-5.515 0-10-4.486-10-10s4.484-10 10-10c5.514 0 10 4.486 10 10s-4.487 10-10 10m6-13.878v8.89a1 1 0 1 1-2 0V8.13l-.006.009-3.097 6.32a1 1 0 0 1-.898.56h-.007a1 1 0 0 1-.897-.572L8.14 8.095s-.033-.081-.066-.062c-.03.007-.033.086-.033.109v8.89a1 1 0 1 1-2 0v-8.89c0-1.008.633-1.835 1.575-2.057.945-.221 1.875.236 2.324 1.136l2.118 4.49 2.186-4.46c.453-.906 1.368-1.371 2.276-1.153.91.215 1.521 1.036 1.521 2.044"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-m_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleM;
